import { Button, Card, message, Typography } from 'antd'
import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { getRegistrationOptions, registerCredential } from '~/api/passkeyApi'
import { registerPasskey } from '~/utils/passkey'

const { Text } = Typography

interface PasskeyRegistrationProps {
  token: string
  onSuccess: () => void
}

const PasskeyRegistration = ({
  token,
  onSuccess
}: PasskeyRegistrationProps) => {
  const [isLoading, setIsLoading] = useState(false)

  const registerMutation = useMutation({
    mutationFn: async (credential: any) => {
      await registerCredential(token, credential)
    },
    onSuccess: () => {
      message.success('Passkey registered successfully!')
      onSuccess()
    },
    onError: (error: any) => {
      message.error(
        error.response?.data?.message ?? 'Failed to register passkey'
      )
      setIsLoading(false)
    }
  })

  const handleRegister = async () => {
    setIsLoading(true)

    try {
      const response = await getRegistrationOptions(token)
      const options = response.data.options

      const credential = await registerPasskey(options)

      registerMutation.mutate(credential)
    } catch (error: any) {
      console.error('Passkey registration error:', error)
      message.error(error.message ?? 'Failed to register passkey')
      setIsLoading(false)
    }
  }

  return (
    <div className='workstation-form'>
      <Card variant='outlined' style={{ width: 400, textAlign: 'center' }}>
        <Typography.Paragraph>
          <Text strong>Register Your Passkey</Text>
        </Typography.Paragraph>
        <Typography.Paragraph>
          You need to register a passkey to access your workstation. This
          passkey will be used to authenticate you on your device.
        </Typography.Paragraph>
        <Typography.Paragraph>
          <Text type='secondary'>
            Click the button below and follow your device's prompts to create a
            passkey.
          </Text>
        </Typography.Paragraph>
        <Button
          type='primary'
          size='large'
          block
          onClick={() => {
            handleRegister()
          }}
          loading={isLoading || registerMutation.isPending}
          style={{ marginTop: 16 }}
        >
          {isLoading || registerMutation.isPending
            ? 'Registering...'
            : 'Register Passkey'}
        </Button>
      </Card>
    </div>
  )
}

export default PasskeyRegistration
